export const campaignColumns = [
  {
    label: "ID",
    field: "id",
    type: "number",
  },
  {
    label: "Campaign Name",
    field: "name",
  },
  {
    label: "Status",
    field: "status",
    formatFn: function (value) {
      return value.toUpperCase();
    },
  },
  {
    label: "Start",
    field: "start_date",
    dateInputFormat: "yyyy-MM-dd HH:mm:ss",
    dateOutputFormat: "yyyy-MM-dd",
  },
  {
    label: "End",
    field: "end_date",
    dateInputFormat: "yyyy-MM-dd HH:mm:ss",
    dateOutputFormat: "yyyy-MM-dd",
  },
  {
    label: "No. Period",
    field: "no_period",
    type: "number",
  },
  {
    label: "Last Modified",
    field: "modified_time",
  },
  {
    label: "Modified By",
    field: "modified_by_username",
  },
];
